// Fonction pour télécharger tous les fichiers
function downloadAllFiles(button) {
  // Trouver la modal parente
  const modal = button.closest('.modal');
  if (!modal) return;
  
  // Récupérer tous les liens de téléchargement dans cette modal
  const fileLinks = modal.querySelectorAll('ul li a[href]');
  
  if (fileLinks.length === 0) {
    console.log('Aucun fichier à télécharger');
    return;
  }
  
  // Télécharger chaque fichier avec un petit délai entre chaque
  fileLinks.forEach((link, index) => {
    setTimeout(() => {
      // Créer un élément <a> temporaire pour déclencher le téléchargement
      const tempLink = document.createElement('a');
      tempLink.href = link.href;
      tempLink.download = ''; // Force le téléchargement au lieu d'ouvrir
      tempLink.style.display = 'none';
      
      document.body.appendChild(tempLink);
      tempLink.click();
      document.body.removeChild(tempLink);
    }, index * 500); // Délai de 500ms entre chaque téléchargement
  });
}

// Attacher l'événement aux boutons "Download All"
document.querySelectorAll('[data-download-all]').forEach(button => {
  button.addEventListener('click', (e) => {
    e.preventDefault();
    downloadAllFiles(button);
  });
});